<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }">Accueil</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Connecteur NETSOINS
        </li>
      </ol>
    </nav>
    <connector-infos
      :cnt-id="adminId"
      :cnt-push-id="pushId"
      :establishments="establishments"
      require-push-id
    />
    <b-row>
      <b-col>
        <b-form-group
          :label="$t('label.select_exist_esta')"
          label-cols-sm="4"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
        >
          <b-input-group size="sm">
            <b-form-input
              list="list_esta"
              id="filterInput"
              v-model="filter"
              type="search"
              @change="filterChange"
              :placeholder="$t('placeholder.find_esta')"
            />
            <b-form-datalist
              id="list_esta"
              :options="filtered"
              value-field="value"
              text-field="text"
              selectable
            >
            </b-form-datalist>
            <b-input-group-append>
              <b-input-group-text>
                <strong>{{ selectedEstablishment?.value }}</strong>
              </b-input-group-text>
              <b-button :disabled="!selectedEstablishment" @click="filter = ''; selectedEstablishment = null; "
                >{{$t('btn.erase')}}</b-button
              >

            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <div>{{ LabelEstaSelected  }}</div>
      </b-col>
    </b-row>
    <hr />
    <b-row v-if="HasSelected">
      <b-col>
        <b-form-group
          :label="$t('connector.label.interface')"
          label-size="sm"
          label-cols-sm="3"
          label-align-sm="left"
          label-for="Interface"
        >
          <b-input-group size="sm">
            <b-form-input
              id="Interface"
              :placeholder="$t('placeholder.connector_interface')"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group
          :label="$t('connector.label.apikey')"
          label-size="sm"
          label-cols-sm="3"
          label-align-sm="left"
          label-for="ApiKey"
        >
          <b-input-group size="sm">
            <b-form-input
              id="apikey"
              :state="goodApiKey"
              v-model="config.apikey"
              :placeholder="$t('placeholder.connector_key')"
              @change="checkKeyUrl"
            ></b-form-input>
            <b-form-invalid-feedback :state="goodApiKey">
                Clé API transmise par Terranga obligatoire (40 caractères).
            </b-form-invalid-feedback>            
          </b-input-group>
        </b-form-group>
        <b-form-group
          :label="$t('connector.label.site_client')"
          label-size="sm"
          label-cols-sm="3"
          label-align-sm="left"
          label-for="Url"
        >
          <b-input-group size="sm">
            <b-form-input
              id="Url"
              v-model="config.apiurl"
              :state="goodUrl"
              @change="checkKeyUrl"
              :placeholder="$t('placeholder.connector_url')"
            ></b-form-input>
           <b-form-invalid-feedback :state="!!config.apiurl">
                Racine du site client pour l'API obligatoire.
            </b-form-invalid-feedback>            

          </b-input-group>
        </b-form-group>

        <b-button
          :disabled="ApiKeyValid"
          @click="onTestApiKey"
          :variant="ApiKeyValid ? 'outline-secondary': 'warning'"
          >{{ $t("connector.btn.test_api") }}</b-button
        >
      </b-col>
    </b-row>
    <b-row v-if="HasSelected && HasConnectorNetsoinsSelected">
      <b-col>
        <b-card
          border-variant="secondary"
          :header="$t('connector.label.consistency')"
          header-border-variant="secondary"
          align="center"
        >
          <b-card-text>
            <connector-consistency
              :esta="selectedEstablishment?.value"
              :cnt="adminId"
              :keyapi="config.apikey"
              :urlapi="config.apiurl"
              :type="config.service.source"
              :useProxy="useProxy"
            />
          </b-card-text>
        </b-card>
        <b-tabs pills card vertical v-model="connectorSelected">
          <b-tab
            v-for="(cnx, index) in connectors"
            :key="index"
            :title="cnx.name"
            v-b-tooltip
            :title-link-class="linkTabClass(index)"
          >
            <template #title>
              <font-awesome-icon
                v-if="cnx.name === 'NETSOINS'"
                :icon="['fas', 'sync-alt']"
              />
              <font-awesome-icon v-else :icon="['fas', 'sign-in-alt']" />
            </template>
            <template v-if="cnx.name === 'NETSOINS'">
              <b-container  >
                <b-row class="w-100 border-top border-bottom border-dark align-items-center">
                  <b-col sm="8" class="text-info mb-3 font-italic">
                    {{ $t("connector.label.synchro_admin") }}
                  </b-col>
                  <b-col sm="2">
                    <b-form-group
                      size="sm"
                      :label="$t('connector.label.enable')"
                      label-size="sm"
                      label-cols-sm="1"
                      label-align-sm="left"
                      label-for="Actif"
                    >
                      <b-form-checkbox
                        id="Actif"
                        v-model="config.enable"
                        :disabled="!ApiKeyValid"
                        switch
                        size="md"
                        variant="success"
                        @change="onToggleEnableSync"
                      >
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col sm="1" >
                    <b-button
                      variant="success"
                      :disabled="!saveEnabled"
                      @click="SaveNETSOINS(cnx)"
                    >{{$t('btn.save')}}</b-button>
                  </b-col>                  
                </b-row>
              </b-container>
              <b-tabs
                content-class="mt-3"
                pills
                card
                justified
                active-nav-item-class="font-weight-bold text-uppercase text-white bg-dark"
              >
                <b-tab
                  :title="$t('connector.label.parameters')"
                  active
                  :disabled="!HasConnectorNetsoinsSelected"
                  title-link-class="text-white bg-secondary"
                >
                  <b-row>
                    <b-col>
                      <b-form-group
                        :label="$t('connector.label.service')"
                        label-size="sm"
                        label-cols-sm="6"
                        label-align-sm="left"
                        label-for="service"
                      >
                        <b-input-group size="sm">
                          <b-form-select
                            id="service"
                            :options="services"
                            v-model="config.service.source"
                          >
                          </b-form-select>
                          <b-form-select
                            id="service"
                            :state="!!config.service.default"
                            :options="estaServices"
                            v-model="config.service.default"
                          >
                          </b-form-select>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group
                        :label="$t('connector.label.push_activities')"
                        label-size="sm"
                        label-cols-sm="6"
                        label-align-sm="left"
                      >
                        <b-row>
                          <b-col>
                            <b-form-checkbox
                              v-model="config.enable_push_activity"
                              switch
                              size="md"
                              variant="success"
                              @change="!$event ? config.enable_push_patgames = false : null"
                            >
                              {{ $t("connector.label.enable") }}
                            </b-form-checkbox>
                          </b-col>
                          <b-col>
                            <b-form-checkbox
                              v-model="config.enable_push_patgames"
                              switch
                              size="md"
                              variant="success"
                              @change="$event ? config.enable_push_activity = true : null"
                            >
                              {{ $t("connector.label.enable_patgames") }}
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_job')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><list-jobs
                                :mappedMetiers="config.metiers"
                                :sourceMetiers="metiers"
                                :keyapi="config.apikey"
                                :urlapi="config.apiurl"
                                @update-metier="updateMetier"
                              />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_filter_job')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><filter-jobs :jobs="filterJobs" @update-filter-job="updateFilterJob" />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab
                  :title="$t('connector.label.mapping')"
                  :disabled="!HasConnectorNetsoinsSelected"
                  title-link-class="text-white bg-secondary"
                >
                  <b-row>
                    <b-col>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_service')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><list-services
                                :type="config.service.source"
                                :keyapi="config.apikey"
                                :urlapi="config.apiurl"
                                :esta="selectedEstablishment?.value"
                                :cnt="NetsoinsConnector?.id"
                                :ctx="config.ctx"
                                :useProxy="useProxy"
                              />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_place')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><list-lieux
                                :keyapi="config.apikey"
                                :urlapi="config.apiurl"
                                :esta="selectedEstablishment?.value"
                                :cnt="NetsoinsConnector?.id"
                                :ctx="config.ctx"
                                :useProxy="useProxy"
                              />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                    </b-col>
                  </b-row>                  <b-row>
                    <b-col>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_resident')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><list-residents
                                :keyapi="config.apikey"
                                :urlapi="config.apiurl"
                                :esta="selectedEstablishment?.value"
                                :cnt="NetsoinsConnector?.id"
                                :ctx="config.ctx"
                                :useProxy="useProxy"
                              />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-container class="full-container">
                        <b-card-group deck>
                          <b-card
                            border-variant="secondary"
                            :header="$t('connector.label.list_personnel')"
                            header-border-variant="secondary"
                            align="center"
                          >
                            <b-card-text
                              ><list-personnels
                                :keyapi="config.apikey"
                                :urlapi="config.apiurl"
                                :esta="selectedEstablishment?.value"
                                :cnt="NetsoinsConnector?.id"
                                :ctx="config.ctx"
                                :useProxy="useProxy"
                              />
                            </b-card-text>
                          </b-card>
                        </b-card-group>
                      </b-container>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </template>
            <template v-else>
              <b-container>
                <b-row class="w-100 border-top border-bottom border-dark align-items-center"
                  ><b-col sm="8" class="text-info mb-3 font-italic">
                    {{ $t("connector.label.push_data") }}
                  </b-col>
                  <b-col sm="2">
                    <b-form-group
                      size="sm"
                      :label="$t('connector.label.enable')"
                      label-size="sm"
                      label-cols-sm="1"
                      label-align-sm="left"
                      label-for="pActif"
                    >
                      <b-form-checkbox
                        id="pActif"
                        v-model="config.enablepush"
                        :disabled="!ApiKeyValid"
                        switch
                        size="md"
                        variant="success"
                        @change="onValidEnablePush"                        
                      >
                      </b-form-checkbox>
                      
                    </b-form-group>
                  </b-col>
                  <b-col sm="1" >
                    <b-button
                      variant="success"
                      :disabled="!saveEnabled"
                       @click="SaveNETSOINSPush(cnx)"
                    >{{$t('btn.save')}}</b-button>
                  </b-col>
                </b-row>
              </b-container>
              <b-container>
                <b-row class="mt-3">
                  <b-col sm="5">
                    <i>{{$t('connector.label.transmission')}}</i>
                  </b-col>
                  <b-col sm="2"></b-col>
                  <b-col sm="5">
                    <i>{{$t('connector.label.report')}}</i>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col sm="5" class="border-top">
                    <b-form-group
                      :label="$t('connector.label.template_html')"
                      label-size="sm"
                      label-cols-sm="4"
                      label-align-sm="left"
                      label-for="tHtml"
                    >
                      <b-form-checkbox
                        id="tHtml"
                        v-model="config.push.trans.html"
                        switch
                        size="md"
                        variant="success"
                      >
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                      :label="$t('connector.label.enable')"
                      label-size="sm"
                      label-cols-sm="4"
                      label-align-sm="left"
                      label-for="tenable"
                    >
                      <b-form-checkbox
                        id="tenable"
                        v-model="config.push.trans.enable"
                        switch
                        size="md"
                        variant="success"
                      >
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                      :label="$t('connector.label.template')"
                      label-size="sm"
                      label-cols-sm="4"
                      label-align-sm="left"
                      label-for="ttemplate"
                    >   
                      <b-input-group size="sm">
                        <b-form-input
                          id="ttemplate"
                          :state="!!config.push.trans.template"
                          v-model="config.push.trans.template"
                          :placeholder="$t('placeholder.connector_template')"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="2" />
                  <b-col sm="5" class="border-top">
                    <b-form-group
                      :label="$t('connector.label.template_html')"
                      label-size="sm"
                      label-cols-sm="4"
                      label-align-sm="left"
                      label-for="rhtml"
                    >
                      <b-form-checkbox
                        id="rHtml"
                        v-model="config.push.report.html"
                        switch
                        size="md"
                        variant="success"
                      >
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                      :label="$t('connector.label.enable')"
                      label-size="sm"
                      label-cols-sm="4"
                      label-align-sm="left"
                      label-for="renable"
                    >
                      <b-form-checkbox
                        id="renable"
                        v-model="config.push.report.enable"
                        switch
                        size="md"
                        variant="success"
                      >
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                      :label="$t('connector.label.template')"
                      label-size="sm"
                      label-cols-sm="4"
                      label-align-sm="left"
                      label-for="rtemplate"
                    >   
                      <b-input-group size="sm">
                        <b-form-input
                          id="rtemplate"
                          :state="!!config.push.report.template"
                          v-model="config.push.report.template"
                          :placeholder="$t('placeholder.connector_template')"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>    
                    <b-table
                      :fields="fieldsRefs"
                      :items="config.push.report.references"
                      small
                      responsive="sm"
                    >
                      <template #cell(name)="row">
                        <b-col>{{ row.item.name }}</b-col>
                      </template>
                      <template #cell(default)="row">
                        <b-col>
                          <b-form-input size="sm"
                            v-model="row.item.default"
                            :placeholder="$t('placeholder.connector_label_name')"
                          ></b-form-input>
                        </b-col>
                      </template>
                      <template #cell(exturi)="row">
                        <b-col>{{ row.item.exturi }}</b-col>
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
              </b-container>
            </template>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <modal-connector-error
      ref="modalError"
      :error-summary="$t('connector.error.netsoins_summary')"
      :errors="detailedErrors"
    />
  </div>
</template>

<script>
import {
  getAllEstablishment,
  getEstablishmentById,
  getServiceForEstablishments,
  SetConnectorData,
  GetConnectorData,
} from "../services/establishment";
import ListJobs from "../components/lists/ListMappingJobs.vue";
import FilterJobs from "../components/lists/ListFilterJobs.vue";
import ListResidents from "../components/lists/ListMappingResidents.vue";
import ListPersonnels from "../components/lists/ListMappingPersonnels.vue";
import ListServices from "../components/lists/ListMappingServices.vue";
import ListLieux from "../components/lists/ListMappingLieux.vue";
import ConnectorInfos from "../components/ConnectorInfos.vue";
import ConnectorConsistency from "../components/ConnectorConsistency.vue";
import ModalConnectorError from "../components/ModalConnectorError.vue";
import { Connectors, JobsList } from "../services/global";
import { Jobs } from "../services/netsoins";
import ApiNetsoins from "../services/proxyNetsoins";
import { checkUrl} from "../misc/urlnetsoins"

export default {
  components: {
    ListJobs,
    ListResidents,
    ListPersonnels,
    ListServices,
    ListLieux,
    FilterJobs,
    ConnectorInfos,
    ConnectorConsistency,
    ModalConnectorError,
  },
  name: "Connector",
  data() {
    return {
      metiers: null,
      estaDetails: null,
      jobs: null,
      filterJobs: null,
      selectedEstablishment: null,
      establishments: null,
      ApiKeyValid: false,
      filtered: null,
      filter: null,
      connectors: null,
      connectorSelected: null,
      services: ["SECTEUR", "SOUSSECTEUR"],
      estaServices: null,
      participants: null,
      useProxy: false,
      config: {
        ctx: null,
        enable: false,
        enablepush: false,
        apikey: null,
        apiurl: null,
        metiers: null,
        enable_push_activity: false,
        enable_push_patgames: false,
        service: {
          source: "SECTEUR",
          default: null,
        },
        jobsfilter: {},
        push: {
          trans: { html: true, enable: false, template: 'anisen.html'},
          report: {html: true, enable: false, template: 'anisenreport.html',
            references: []
          }
        }
       
      },
      fieldsRefs: [
        {
          name: {
            label: "Type",
            sortable: true,
            tdClass: "align-middle text-left",
          },
        },
        {
          default: {
            label: "Nom NETSOINS",
            sortable: true,
            tdClass: "align-middle text-left",
          },
        },
        {
          exturi: {
            label: "id partenaire",
            sortable: true,
            tdClass: "align-middle",
          },
        },      
      ],
      saveEnabled: false,
      errorDirect: null,
      errorProxy: null,
    };
  },
  async created() {
    let cons;

    [
      this.jobs,
      this.establishments,
      cons,
    ] = await Promise.all([
      JobsList(),
      getAllEstablishment(null, true),
      Connectors("NETSOINS"),
    ]);

    this.filtered = this.establishments.map((e) => {
      {
        return e.text;
      }
    });

    if (cons) {
      this.connectors = cons;
    } else {
      this.connectors = [
        { id: 1, name: "NETSOINS", model: null, enable: true },
        { id: 2, name: "NETSOINS_PUSH", model: null, enable: true },
      ];
    }
    this.connectorSelected = 0;
  },
  methods: {
    updateMetier(item){
      const mapped = this.config.metiers.find(m=>m.ext_id === item.Uri);
      if (mapped) {
        mapped.id = item.id;
      } else {
        this.config.metiers.push({
          ext_id: item.Uri,
          ext_name: item.Libelle,
          id: item.id
        })
      }
    },
    updateFilterJob(item){
      const i = this.config.jobsfilter.indexOf( item.Id)
      if (!item.Include && i !== -1) this.config.jobsfilter.splice(i, 1)
      if (item.Include && i === -1) this.config.jobsfilter.push(item.Id)
    },
    async SaveNETSOINS(cnx){
      const result = await SetConnectorData(this.selectedEstablishment.value, cnx, this.config);
      this.config.saved = result.good;
      if (this.config.saved && !this.config.ctx) this.config.ctx = result.eec_id;
    },
    async SaveNETSOINSPush(cnx){
      const result = await SetConnectorData(this.selectedEstablishment.value, cnx, this.config);
      this.config.savedpush = result.good;
      if (this.config.savedpush && !this.config.ctx) this.config.ctx = result.eec_id;
    },    
    async onConnectorSelected(items) {
      this.connectorSelected = items[0];
    },
    async filterChange() {
      this.saveEnabled = false;
      
      this.ApiKeyValid = false;
      this.selectedEstablishment = this.establishments.find(
        (e) => this.filter === e.text
      );
      if (this.selectedEstablishment) {
        this.estaDetails = await getEstablishmentById(this.selectedEstablishment.value);
        this.estaServices = await getServiceForEstablishments(
          this.selectedEstablishment.value,
          true
        );
        if (this.estaServices) {
          this.config.service.default = this.estaServices.find(
            (s) => s.default === true
          )?.value;
        }
        this.getConnectorsForEsta();
        this.saveEnabled = true;
      } 
      else {      
        this.defaultConfig();
      }

    },
    async onTestApiKey() {
      this.errorDirect = null;
      this.errorProxy = null;

      try {
        if (this.useProxy) {
          throw Error("Proxy must be used");
        }

        this.metiers = await Jobs({
          uri: this.config.apiurl,
          key: this.config.apikey,
        });
      }
      catch (errorDirect) {
        // Direct call didn't work => Try to use the proxy

        try {
          const api = new ApiNetsoins(this.config.apikey, this.config.apiurl, this.config.service.source);
          this.metiers = await api.getJobs();

          // Proxy call worked => We have to use the proxy
          this.useProxy = true;
        }
        catch (errorProxy) {
          // Proxy call also failed
          this.errorDirect = errorDirect;
          this.errorProxy = errorProxy;

          this.$refs.modalError.show();
        }
      }
      //console.log('metiers', this.metiers)
      this.ApiKeyValid = this.metiers !== null;

    },
    checkKeyUrl() {
      if (this.config?.apikey?.length > 0 && this.config?.apiurl?.length > 0)
        {
          //console.log('HasKey');
          this.onTestApiKey();
        }
      else {
        this.ApiKeyValid = false;
      }
    },
    async getConnectorsForEsta() {
      this.defaultConfig();

      const conf = await GetConnectorData(
      this.selectedEstablishment.value,
      this.connectors 
      );
      if (conf) {
        this.config = conf;
      }
      this.filterJobs = this.jobs
        .map((j) => {
          return {
            Id: j.value,
            Name: j.text,
            Include: !(conf.jobsfilter)? false: conf.jobsfilter?.find((f) => f === j.value) != null,
          };
        })
        .sort((a, b) => a.Id - b.Id);

      this.checkKeyUrl();
    },
    linkTabClass(idx) {
      if (this.connectorSelected === idx) {
        return ["bg-info", "text-white"];
      } else {
        return ["bg-light", "text-info"];
      }
    },
    onValidEnablePush(){
      if (this.config.enablepush && !this.config.enable) {
        
        this.showToastError('danger', 'Impossible d\'activé ce connecteur avant la synchro des données' , 'Activation');
        this.config.enablepush = false;
      }
    },
    onToggleEnableSync(){
      if (!this.config.enable) this.config.enablepush = false;
    },
    defaultConfig(){
      this.metiers = null
      this.useProxy = false
      this.config = {
          ctx: null,
          enable: false,
          enablepush: false,
          apikey: null,
          apiurl: null,
          metiers: null,
          enable_push_activity: false,
          enable_push_patgames: false,
          service: {
            source: "SECTEUR",
            default: null,
          },
          jobsfilter: {},
          push: {
            trans: { html: true, enable: false, template: 'anisen.html'},
            report: {html: true, enable: false, template: 'anisenreport.html',
              references: []
            }
          } 
      }
    }
  },
  computed: {
    adminId() {
      return this.connectors?.find(cnt => cnt.name === "NETSOINS")?.id;
    },
    pushId() {
      return this.connectors?.find(cnt => cnt.name === "NETSOINS_PUSH")?.id;
    },
    LabelEstaSelected(){
      return `${(this.selectedEstablishment)? this.selectedEstablishment.text : ''} - ${ (this.estaDetails) ? this.estaDetails.esta_postalcode: ''} ${(this.estaDetails)? this.estaDetails.esta_city: ''} ${(this.estaDetails && this.estaDetails.parent?.esta_id > 0)? '(' + this.estaDetails.parent.esta_name + ')' : ''}`;
    },
    HasSelected() {
      return this.selectedEstablishment?.value > 0;
    },
    HasConnectorSelected() {
      return this.connectorSelected?.id > 0;
    },
    HasConnectorNetsoinsSelected() {
      return this.ApiKeyValid;
    },
    NetsoinsConnector() {
      return this.connectors?.[this.connectorSelected];
    },
    goodUrl(){
      return checkUrl(this.config.apiurl)
    },
    goodApiKey(){
      return this.config?.apikey?.length === 40;
    },
    detailedErrors() {
      return [
        !this.useProxy
          ? {
              title: this.$t("connector.error.direct_title", ["NETSOINS"]),
              error: this.errorDirect,
            }
          : null,
        {
          title: this.$t("connector.error.proxy_title", ["NETSOINS"]),
          error: this.errorProxy,
        },
      ].filter(e => e !== null);
    },
  },
};
</script>

<style scoped >
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff !important;
  border-color: #138022 !important;
  background-color: #138022 !important;
}
</style>
